// extracted by css-extract-rspack-plugin
export default {"separator":"KeyboardShortcut-module__separator___sXW3Q"};